import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-633dd351")

_pushScopeId("data-v-633dd351")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "block-title" }, "Salesperson Accounts", -1)
const _hoisted_2 = { class: "data-table" }
const _hoisted_3 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", {
      style: {"width":"100%"},
      class: "label-cell"
    }, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "label-cell" }, "Email"),
    /*#__PURE__*/_createVNode("th", { class: "numeric-cell" }, "Points"),
    /*#__PURE__*/_createVNode("th", { class: "label-cell text-align-center" }, "Sees Points"),
    /*#__PURE__*/_createVNode("th", { class: "actions-cell" })
  ])
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "label-cell" }
const _hoisted_6 = { class: "label-cell" }
const _hoisted_7 = { class: "numeric-cell" }
const _hoisted_8 = { class: "text-align-center" }
const _hoisted_9 = { class: "actions-cell" }
const _hoisted_10 = { class: "input-cell" }
const _hoisted_11 = {
  class: "input input-outline",
  style: {}
}
const _hoisted_12 = /*#__PURE__*/_createVNode("td", { class: "label-cell" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("td", { class: "numeric-cell" }, null, -1)
const _hoisted_14 = { class: "text-align-center" }
const _hoisted_15 = { class: "actions-cell" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "skeleton-text skeleton-effect-wave" }, "Loading...", -1)
const _hoisted_18 = {
  class: "data-table-footer",
  style: {"min-height":"var(--f7-table-body-cell-height)"}
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Add Salesperson")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_checkbox = _resolveComponent("f7-checkbox")
  const _component_f7_icon = _resolveComponent("f7-icon")
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_button = _resolveComponent("f7-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("table", null, [
        _hoisted_3,
        (!_ctx.rewardsStore.isLoading)
          ? (_openBlock(), _createBlock("tbody", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rewardsStore.salespersons, (salesperson) => {
                return (_openBlock(), _createBlock("tr", {
                  key: salesperson.id
                }, [
                  _createVNode("td", _hoisted_5, _toDisplayString(salesperson.name), 1),
                  _createVNode("td", _hoisted_6, _toDisplayString(salesperson.email), 1),
                  _createVNode("td", _hoisted_7, _toDisplayString(salesperson.points), 1),
                  _createVNode("td", _hoisted_8, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_f7_icon, {
                          key: 0,
                          class: "icon-tooltip",
                          tooltip: "This can be changed in account details"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_f7_checkbox, {
                              checked: salesperson.canViewLoyaltyProgram,
                              disabled: ""
                            }, null, 8, ["checked"])
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createBlock(_component_f7_checkbox, {
                          key: 1,
                          checked: salesperson.canViewLoyaltyProgram,
                          disabled: ""
                        }, null, 8, ["checked"]))
                  ]),
                  _withDirectives(_createVNode("td", _hoisted_9, [
                    _createVNode(_component_f7_link, {
                      href: `/builders/${salesperson.id}`,
                      "icon-aurora": "f7:square_arrow_right",
                      tooltip: "View account details"
                    }, null, 8, ["href"]),
                    _createVNode(_component_f7_link, {
                      onClick: ($event: any) => (_ctx.confirmRemoveSalesperson(salesperson.id)),
                      "icon-aurora": "f7:trash",
                      color: "red",
                      tooltip: "Remove from list"
                    }, null, 8, ["onClick"])
                  ], 512), [
                    [_vShow, _ctx.isAdmin]
                  ])
                ]))
              }), 128)),
              _withDirectives(_createVNode("tr", null, [
                _createVNode("td", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _withDirectives(_createVNode("input", {
                      id: "new-salesperson-id",
                      type: "text",
                      placeholder: "Search for a salesperson",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newSalespersonName = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.newSalespersonName]
                    ])
                  ])
                ]),
                _hoisted_12,
                _hoisted_13,
                _createVNode("td", _hoisted_14, [
                  _createVNode(_component_f7_checkbox, {
                    checked: _ctx.newSalespersonSeesPoints,
                    "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newSalespersonSeesPoints = $event))
                  }, null, 8, ["checked"])
                ]),
                _withDirectives(_createVNode("td", _hoisted_15, [
                  _createVNode(_component_f7_link, {
                    onClick: _ctx.saveSalesperson,
                    "icon-aurora": "f7:checkmark",
                    tooltip: "Save"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_f7_link, {
                    onClick: _ctx.cancelAddSalesperson,
                    "icon-aurora": "f7:xmark",
                    color: "red",
                    tooltip: "Cancel"
                  }, null, 8, ["onClick"])
                ], 512), [
                  [_vShow, _ctx.isAdmin]
                ])
              ], 512), [
                [_vShow, _ctx.showAddRow]
              ])
            ]))
          : (_openBlock(), _createBlock("tbody", _hoisted_16, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
                return _createVNode("tr", { key: i }, [
                  (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (j) => {
                    return _createVNode("td", { key: j }, [
                      _hoisted_17
                    ])
                  }), 64))
                ])
              }), 64))
            ]))
      ]),
      _withDirectives(_createVNode("div", _hoisted_18, [
        _createVNode(_component_f7_button, {
          style: {"width":"100%"},
          "icon-aurora": "f7:plus",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddRow = true))
        }, {
          default: _withId(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _ctx.isAdmin && !_ctx.showAddRow]
      ])
    ])
  ], 64))
})